<template>
    <modal title="" width="45" :showModal="showModal" @close-modal="closeModal" :showTitle="false">
        <div class="w-full h-full overflow-y-auto">
            <div class="flex items-center justify-between mb-4 w-full sticky top-0">
                <span class="back_svg" @click="closeModal">
                    <img src="@/assets/images/icons/back-icon.svg" />
                </span>
                <span>
                    Report an Incident
                </span>
            </div>
            <div class="my-2 mt-0">
                <p class="mb-4">
                    <b class="text-sm">What kind of assistance do you require?</b>
                </p>

                <div class="slice-option mb-3">
                    <label class="label">Location:</label>
                    <div class="w-full flex items-center gap-4 justify-start">
                        <label for="senderSelf" class="radio-label">
                            <input class=" bg-primary-yellow text-secondary-yellow" name="sendertype" type="radio"
                                id="currentLocation" value="current" v-model="locationType" />
                            Use current Location
                            <span></span>
                        </label>

                        <label for="senderOthers" class="radio-label">
                            <input type="radio" v-model="locationType" value="input" id="otherLocation"
                                name="sendertype" />
                            Input address
                            <span></span>
                        </label>
                    </div>
                    <div>
                        <Addressinput class="address_input w-full" placeholder="--Enter Address--"
                            :locationDetails="viewLocationDetails" :value="location" />
                    </div>
                </div>

                <div class="slice-option">
                    <label class="label">Incident Category</label>
                    <el-select v-model="requestCategory" placeholder="Select Type">
                        <el-option v-for="value in assitantCategory" :key="value.value" :label="value.title"
                            :value="value.value"></el-option>
                    </el-select>
                </div>

                <div class="slice-option">
                    <label class="label">Severity</label>
                    <el-select v-model="severity" placeholder="Select Type">
                        <el-option label="Low" value="low"></el-option>
                        <el-option label="Medium" value="medium"></el-option>
                        <el-option label="High" value="high"></el-option>
                        <el-option label="Critical" value="critical"></el-option>
                    </el-select>
                </div>

                <div class="w-full mt-3">
                    <label class="label">Tell us more</label>
                    <textarea @input="checkTextlength($event)" type="number" v-model="moreDetails"
                        placeholder="Text Area" class="input-mini_textarea"></textarea>
                    <div class="text-right">
                        {{ (moreDetails || "").length }}/300
                    </div>
                </div>

                <div class="mt-3">
                    <b class="bold_upl">Upload File</b>
                    <label class="w-fill block text-sm opacity-50">(File accepted: .jpg, .jpeg, .png - Max file
                        size:2mb)</label>
                    <div class="mt-2 select_contaioner">
                        <span class="select_btn cursor-pointer" @click="openFile">
                            <img src="../components/icons/selectIcon.svg" class="mr-2" /> Select file
                            <input class="hidden" type="file" ref="fileinput" id="fileinput" />
                        </span>
                    </div>
                </div>

                <div class="flex justify-end mt-5 mb-3">
                    <primary-button @click="updateIncident" class="shadow-md font-normal " buttonText="Submit"
                        :loading="loading" />
                </div>

            </div>
        </div>
    </modal>
</template>

<script>
import Addressinput from "../../../Ondemand/UI/Addressinput.vue";

export default {
    components: { Addressinput },
    props: {
        showModal: {
            type: Boolean,
            required: true,
        },
        activeGroup: {
            required: false
        }
    },
    data() {
        return {
            requestCategory: "",
            loading: false,
            moreDetails: "",
            severity: "",
            locationType: "input",
            location: "",
            assitantCategory: [
                { value: "transload", title: "Transload" },
                { value: "maintenance", title: "Maintenance" },
                { value: "emergency", title: 'Emergency' },
                { value: "other", title: "Other" },
            ],
        };
    },
    watch: {
        showModal(val) {
            if (val) {
                console.log(this.activeGroup);
                this.requestCategory = this.activeGroup?.requestCategory;
                this.severity = this.activeGroup?.severity;
                this.moreDetails = this.activeGroup?.requestDetail;
            }
        },
        locationType(newVal) {
            if (newVal === "self") {
                this.getUserCurrentLocation();
            }
        }

    },
    computed: {
        payload() {
            return {
                requestCategory: this.requestCategory.toLowerCase(),
                severity: this.severity.toLowerCase(),
                address: this.location.address,
                requestDetail: this.moreDetails,
                userId: this.$store.getters.userId,
                shippingRef: this.activeGroup.shippingRef,
                shippingDispatchRef: this.activeGroup.shippingDispatchRef,
                fleetType: this.activeGroup.fleetType,
                fleetRegistration: this.activeGroup.fleetRegistration,
                fleetName: this.activeGroup.fleetName,
                comments: this.moreDetails
            }
        }
    },
    methods: {
        async updateIncident() {
            this.loading = true
            try {
                let response = await this.$_updateIncident(this.activeGroup.id, this.payload);
                console.log(response);
                this.closeModal();
                this.$emit('refresh')
            } catch (error) {
                this.handleError(error);
            } finally {
                this.loading = false
            }
        },
        openFile() {
            document.querySelector('#fileinput').click()
        },
        viewLocationDetails(val) {
            console.log(val)
            this.location = val;
        },
        checkTextlength(event) {
            let value = event.target.value;
            if ((this.moreDetails || "").length > 300) {
                this.moreDetails = value.substring(0, 300);
                return;
            }
            this.moreDetails = value;
        },
        closeModal() {
            this.$emit("closeModal");
        },
        // ✅ Get current location function
        getUserCurrentLocation() {
            if (!navigator.geolocation) {
                console.error("Geolocation is not supported by this browser.");
                return;
            }

            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    console.log("User location:", latitude, longitude);
                    this.location = { lat: latitude, lng: longitude };
                },
                (error) => {
                    switch (error.code) {
                        case error.PERMISSION_DENIED:
                            console.error("User denied the request for Geolocation.");
                            break;
                        case error.POSITION_UNAVAILABLE:
                            console.error("Location information is unavailable.");
                            break;
                        case error.TIMEOUT:
                            console.error("The request to get user location timed out.");
                            break;
                        case error.UNKNOWN_ERROR:
                        default:
                            console.error("An unknown error occurred while fetching location.");
                            break;
                    }
                },
                { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
            );
        }

    },
};
</script>

<style lang="scss" scoped>
.select_contaioner {
    @apply rounded border-gray-200 p-[1px];
    border-width: 1px;
}

.select_btn {
    @apply text-sm bg-secondary-yellow rounded inline-flex px-2 py-2 items-center
}

.bold_upl {
    @apply font-[500] text-sm
}

.address_input {
    @apply w-full rounded-md border-gray-700/10 border-[1px] bg-transparent;
}

.address_input input {
    @apply py-2 px-2 w-full bg-transparent
}

.slice-option {
    @apply w-full;
}

.slice-option_address {
    @apply mt-2 w-full mb-3;
}

.slice-option_picker {
    @apply mt-4 sm:mt-8 sm:w-[48%] lg:w-[32%] w-full mr-[2%] lg:mr-[1.333%];
}

.input-mini {
    @apply w-full py-2 px-2 border-[1px] border-gray-700/10 rounded-md bg-transparent;
}

.input-mini_textarea {
    @apply w-full py-2 px-2 border-[1px] border-gray-700/10 rounded-md bg-transparent resize-none h-24;
}

.radio-label {
    @apply flex items-center
}

.back_svg {
    @apply inline-flex w-[30px] h-[30px] justify-center items-center bg-gray-100 rounded cursor-pointer;

    img {
        @apply w-6/12
    }
}
</style>